import Axios from 'axios';
import React, { Fragment, useEffect, useRef, useState } from 'react';
import config from '../../Config/key';
import {
  Table,
  Divider,
  Button,
  message,
  Typography,
  Select,
  Modal,
  Space,
  Spin,
  TreeSelect,
  Checkbox,
  Alert,
} from 'antd';
import {
  DeleteOutlined,
  CarryOutOutlined,
  BankOutlined,
  PlusOutlined,
  DownloadOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import {
  DEPT_TREE_SELECT_PROPS,
  buildDepartmentTree,
  fetchOrgTreeAt,
} from '../../../utils/orgReportFilter';
// 所属指定の Excel 一括登録（「部署指定拡張」PJ Ph.2）
import {
  buildE3BulkModel,
  buildSeasonChoices,
  downloadE3DeptTemplate,
  downloadE3DeptCurrent,
} from '../../../utils/e3DeptBulk';
import E3DeptBulkUploadModal from './E3DeptBulkUploadModal';
// 系列会社ありグループの「系列会社 → 所属」ツリー（「グループ会社・系列会社構造」PJ Ph.4b）
import { resolveCompanyRule } from '../../../utils/companyRule';
import {
  buildCompanyDeptTree,
  fetchDeptPathsByCompany,
  toYmdDash,
} from '../../../utils/companyDeptSource';
// 所属指定の保存形式（空欄なし可変長・最大 50 件。「部署指定拡張」PJ Ph.1）
import {
  E3_DEPARTMENT_MAX,
  normalizeE3DepartmentList,
} from '../../../utils/e3Department';
import { userRole } from '../../Config/userRole';
// 回答状況指定（診断の種類ごと。2026-10 追加パッチ）
import { answerStatusKindOf } from '../../../utils/answerStatusView';
import { useSelector } from 'react-redux';
// テーブル強化 PJ Ph.3 拡大: 列リサイズ + ソート + 省略
import {
  PageContainer,
  EmptyState,
  useResizableColumns,
  ellipsisColumn,
  textSorter,
} from '../../common';
const { Text } = Typography;
const { Option } = Select;

// 回答状況指定の種類（サーバー utils/answerStatusView.js と同じ。表示順）
const ANSWER_KINDS = [
  {
    key: 'engagement',
    label: 'エンゲージメント',
    short: 'エンゲージメント',
    help: '「メンバー回答状況」でエンゲージメントのシーズンを選べます（シーズン指定に関係なく、すべてのシーズン）。',
  },
  {
    key: 'team',
    label: '360度系（360度診断・フォロワーシップ）',
    short: '360度系',
    help: '「チーム回答状況」のメニューを表示します（シーズン指定があれば、選んだシーズンだけ）。閲覧不可にすると「メンバー回答状況」でも 360度系のシーズンを選べません。',
  },
  {
    key: 'other',
    label: 'その他',
    short: 'その他',
    help: '「メンバー回答状況」でその他の診断のシーズンを選べます（シーズン指定があれば、選んだシーズンだけ）。',
  },
];
// 値が無い既存ユーザー・値が無い種類は閲覧可
const answerViewOfRecord = (record) => {
  const v = (record && record.answer_status_view) || {};
  return { engagement: v.engagement !== false, team: v.team !== false, other: v.other !== false };
};
// const survey_status_complete = 5;

function E3DepMgrPage() {
  const [viewModal, setViewModal] = useState(false);
  const [treeData, setTreeData] = useState([]);
  // 選択中グループが系列会社ありか（所属指定の値 = 「系列会社名」または「系列会社名／所属…」）
  const [isAffiliateGroup, setIsAffiliateGroup] = useState(false);
  const treeSeq = useRef(0); // 所属ツリーの取得順（企業を素早く切り替えた時に古い結果を捨てる）
  const [uId, setUId] = useState();
  const [userInfo, setUserInfo] = useState({});
  // 「部署指定」モーダルの編集中の行（1 行 = 1 所属。'' = 未選択の行）。最大 E3_DEPARTMENT_MAX 行
  const [selDepts, setSelDepts] = useState(['']);
  const [savingDepts, setSavingDepts] = useState(false);
  // Excel 一括登録: 今日時点の有効な確定組織表から作るモデル（無ければ null = ボタン非表示）
  const [bulkModel, setBulkModel] = useState(null);
  const [bulkVersion, setBulkVersion] = useState(null);
  const [bulkModalOpen, setBulkModalOpen] = useState(false);
  const bulkSeq = useRef(0); // 企業を素早く切り替えた時に古い結果を捨てる
  // const [isAnswerd, setIsAnswerd] = useState(9);
  // const [usedToken, setUsedToken] = useState([]);
  // const [Users, setUsers] = useState([]); //全てのユーザ一覧
  // const [tUsers, setTUsers] = useState([]); //グループフィルタリングされたユーザ一覧（全体）
  const [gUsers, setGUsers] = useState([]); //グループ・サーベイシーズンでフィルタリングされたユーザ一覧
  const [groups, setGroups] = useState([]); //グループ名とグループコード
  //survey_code → 現在の survey_name マップ（Survey コレクションが正本。表示時に古いスナップショットを上書き）
  const [surveyByCode, setSurveyByCode] = useState(new Map());
  //「シーズン指定」 モーダル用 state
  const [answerModalUser, setAnswerModalUser] = useState(null); //回答状況指定モーダルの対象ユーザー（null = 閉じている）
  const [answerView, setAnswerView] = useState({ engagement: true, team: true, other: true }); //モーダル内の値
  const [savingAnswer, setSavingAnswer] = useState(false);
  const [seasonModalOpen, setSeasonModalOpen] = useState(false); //シーズン指定モーダルの開閉
  const [selSeasonIds, setSelSeasonIds] = useState([]); //モーダル内で選択中のシーズン ID 配列 (string[])
  const [editSeasonUid, setEditSeasonUid] = useState(); //シーズン指定中のユーザー ID
  const [editSeasonUserName, setEditSeasonUserName] = useState(''); //モーダルタイトル表示用
  const [currentGroupSeasons, setCurrentGroupSeasons] = useState([]); //選択中グループの SurveySeason 配列 (group.survey_season をそのまま)
  // const [selGroupInfo, setSelGroupInfo] = useState([]); //グループ名とグループコード
  // const [surveySeason, setSurveySeason] = useState([]);
  // const [selSurveySeason, setSelSurveySeason] = useState([]);
  const [selGroupCode, setSelGroupCode] = useState(''); //選択されたグルプコード
  // const [survey, setSurvey] = useState([]); //サーベイ名とサーベイコード
  // const [questionSetFilter, setQuestionSetFilter] = useState([]); //全ての設問セット
  // const [selQuestionSetFilter, setSelQuestionSetFilter] = useState([]); //全ての設問セット
  // const [questionSet, setQuestionSet] = useState([]); //全ての設問セット
  // const [selSurveyId, setSelSurveyId] = useState(''); //選択したサーベイID
  // const [role360, setRole360] = useState(1); //選択した360度関係：１：本人、２：上司、３：部下・同僚
  // const [selSurveySeasonId, setSelSurveySeasonId] = useState(''); //選択したサーベイID
  // const [selSurveySeasonIdFilter, setSelSurveySeasonIdFilter] = useState(''); //選択したサーベイID
  // const [selQuestionSetFilterId, setSelQuestionSetFilterId] = useState(''); //選択した設問セットID
  // const [rowKeys, setRowKeys] = useState({
  //   //選択されたユーザ一覧
  //   selectedRowKeys: [], // Check here to configure the default column
  //   loading: false,
  // });
  const usr = useSelector((state) => state.user);
  //9:管理者９が最高管理者
  // const userRole = [
  //   '停止中',
  //   '学習者',
  //   '管理者',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   'その他',
  //   '最高管理者',
  // ];

  const readDB = async () => {
    try {
      if (!usr.userData) return null;
      // console.log(usr.userData);
      setUserInfo(usr.userData);

      const groupInfo = await Axios.get('/api/group/'); //DBからグループ情報取得
      //サーベイ名の正本（Survey コレクション）を取得し survey_code → survey_name マップを構築
      const surveyInfo = await Axios.get('/api/survey/');
      const sList = surveyInfo.data.success ? surveyInfo.data.survey : [];
      setSurveyByCode(new Map(sList.map((s) => [s.survey_code, s.survey_name])));
      if (usr.userData.groupCode === 'RECRNT' && usr.userData.role === 2) {
        const nonGroup = groupInfo.data.groups.filter(
          (item) => item.group_code !== 'RECRNT'
        );
        setGroups(nonGroup);
      } else {
        setGroups(groupInfo.data.groups);
      }
      setGUsers([]);
      if (!groups) throw 'グループ取得に失敗しました。';
      if (usr.userData.role === 3) {
        const g = groupInfo.data.groups.find(
          (item) => item.group_code === usr.userData.groupCode
        );
        // console.log({ g });
        setSelGroupCode(g.group_code);
        filterDatasource(g.group_code);
        loadTreeForGroup(g);
        //「シーズン指定」 モーダル用にこのグループのシーズン一覧を保持
        setCurrentGroupSeasons(g.survey_season || []);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    readDB();
  }, [usr]);

  //リストフィルタリング
  const filterDatasource = async (groupCode) => {
    message.loading({
      content: '読み込み中...',
      key: 'updateable',
      duration: 20,
    });
    //role 7 (企業管理者シーズン指定) ユーザーを取得 (accessible_survey_seasons は populate 済み)
    const res = await Axios.get(
      `${config.USER_SERVER}/role7group/${groupCode}`
    );
    // console.log({ res });
    let userData = res.data.users;
    await userData.map((user) => {
      user.fullName = user.lastname + ' ' + user.name;
      user.roleText = userRole[user.role];
      //シーズン指定件数 (テーブル列のボタン表示に使用)
      user.accessibleSeasonCount = Array.isArray(user.accessible_survey_seasons)
        ? user.accessible_survey_seasons.length
        : 0;
      if (user.survey_token.length === 0) {
        user.takeTokenCnt = 0;
        user.usedTokenCnt = 0;
        user.surveyProgress = 0;
      } else {
        user.takeTokenCnt = user.survey_token.length;
        user.usedTokenCnt = user.survey_token.filter(function (tokenInfo) {
          return tokenInfo.survey_status === 5; //実施済み：5
        }).length;
        user.surveyProgress = (user.usedTokenCnt / user.takeTokenCnt) * 100;
      }
      return user;
    });
    setGUsers(userData);
    // setTUsers(userData);
    message.success({
      content: '読み込み完了！',
      key: 'updateable',
      duration: 2,
    });
  };

  // 部署経路 → TreeSelect 用ツリー（共用ヘルパー。7 階層・親は経路の完全一致で解決）
  const genTree = (depArr) =>
    buildDepartmentTree(depArr, { icon: <CarryOutOutlined /> });

  // 所属指定の TreeSelect の選択肢を作る（Ph.4b）。
  // 系列会社ありグループ = 「系列会社 → 所属」ツリー（ルート = 系列会社名・会社ノード自体も選択可 = その会社全体。
  // 所属は今日時点の確定組織表のその会社配下、組織表が無ければユーザーの所属から導出）。
  // 系列会社なしグループ = 従来どおり Group.department
  const loadTreeForGroup = async (group) => {
    loadBulkModel(group);
    const seq = ++treeSeq.current;
    if (!group || group.has_affiliates !== true) {
      setIsAffiliateGroup(false);
      setTreeData(genTree(group ? group.department : []));
      return;
    }
    setIsAffiliateGroup(true);
    setTreeData([]);
    const today = toYmdDash();
    const rule = await resolveCompanyRule(group.group_code, group, today);
    const pathsByCompany = await fetchDeptPathsByCompany(group.group_code, rule.names, today);
    if (seq !== treeSeq.current) return;
    setTreeData(
      buildCompanyDeptTree(rule.names, pathsByCompany, {
        icon: <CarryOutOutlined />,
        companyIcon: <BankOutlined />,
      })
    );
  };
  // Excel 一括登録のモデル。部署指定は今日時点の有効な確定組織表がある企業だけ（系列会社ありグループは系列会社ノードも必要）。
  // 組織表が無い企業でもシーズン指定・回答状況指定は一括登録できる（2026-11。model.available=false = 部署指定なし）
  const loadBulkModel = async (group) => {
    const seq = ++bulkSeq.current;
    setBulkModel(null);
    setBulkVersion(null);
    if (!group) return;
    const { version, units } = await fetchOrgTreeAt(group.group_code, toYmdDash());
    if (seq !== bulkSeq.current) return;
    const model = buildE3BulkModel(version ? units : [], {
      hasAffiliates: group.has_affiliates === true,
    });
    setBulkModel(model);
    setBulkVersion(model.available ? version : null);
  };
  const handleTemplateDownload = async () => {
    try {
      // email 列のドロップダウン = 一覧に表示中の企業のシーズン管理者（role 7）
      // シーズン指定シートの選択肢 = 企業の全シーズン（Ph.4）
      await downloadE3DeptTemplate(bulkModel, selGroupCode, {
        users: gUsers.map((u) => ({ email: u.email, name: u.fullName })),
        seasons: buildSeasonChoices(currentGroupSeasons, surveyByCode),
      });
    } catch (error) {
      message.error('テンプレートを作成できませんでした。');
      console.log(error);
    }
  };
  //現在の登録内容をテンプレートと同じ形でダウンロード（Ph.5）
  const handleCurrentDownload = async () => {
    try {
      const now = new Date();
      const pad = (n) => ('0' + n).slice(-2);
      await downloadE3DeptCurrent(bulkModel, selGroupCode, {
        users: gUsers.map((u) => ({
          email: u.email,
          name: u.fullName,
          e3_department: u.e3_department,
          accessible_survey_seasons: u.accessible_survey_seasons,
          answer_status_view: u.answer_status_view,
        })),
        seasons: buildSeasonChoices(currentGroupSeasons, surveyByCode),
        asOf: `${now.getFullYear()}/${pad(now.getMonth() + 1)}/${pad(now.getDate())} ${pad(now.getHours())}:${pad(now.getMinutes())}`,
      });
    } catch (error) {
      message.error('現在の設定を出力できませんでした。');
      console.log(error);
    }
  };
  const handleBulkDone = async () => {
    setBulkModalOpen(false);
    await filterDatasource(selGroupCode);
  };
  const formatYmd = (value) => {
    const d = value ? new Date(value) : null;
    return d && !isNaN(d.getTime()) ? toYmdDash(d).replace(/-/g, '/') : '';
  };

  //グループを変更した場合
  const onChangeGroup = async (value) => {
    // console.log(`selected ${value}`);
    setSelGroupCode(value);
    filterDatasource(value); //リストフィルタリング
    const selGroup = groups.find((item) => item.group_code === value);
    loadTreeForGroup(selGroup);
    //「シーズン指定」 モーダル用にこのグループのシーズン一覧を保持
    setCurrentGroupSeasons(selGroup.survey_season || []);
    // console.log(treeData);
  };

  //「部署指定」ボタンを押した時: 保存済みの所属指定を全件（空欄を除く）行として開く。指定が無ければ空の 1 行
  const viewTicketHandler = (user, e) => {
    e.preventDefault();
    const current = normalizeE3DepartmentList(user.e3_department);
    setSelDepts(current.length > 0 ? current : ['']);
    setUId(user._id);
    setViewModal(true);
  };

  //「部署指定」モーダルの保存: 空欄の行を除き、重複をまとめて送信する
  const handleOk = async (e) => {
    e.preventDefault();
    const e3Department = normalizeE3DepartmentList(selDepts);
    setSavingDepts(true);
    try {
      const res = await Axios.patch(
        `${config.USER_SERVER}/${uId}/e3department`,
        { e3_department: e3Department }
      );
      if (res.data.success) {
        setViewModal(false);
        await filterDatasource(selGroupCode);
        message.success('保存しました。');
      }
    } catch (error) {
      const serverError =
        error && error.response && error.response.data && error.response.data.error;
      message.error(
        serverError ? `部署情報の保存に失敗しました。${serverError}` : '部署情報の保存に失敗しました。'
      );
      console.log(error);
    } finally {
      setSavingDepts(false);
    }
  };

  const handleCancel = (e) => {
    // console.log(e);
    setViewModal(false);
  };

  //「回答状況指定」モーダル（診断の種類ごとに 閲覧可／閲覧不可。2026-10 追加パッチ・utils/answerStatusView.js）
  const openAnswerModal = (user, e) => {
    e.preventDefault();
    setAnswerView(answerViewOfRecord(user));
    setAnswerModalUser(user);
  };
  const handleAnswerOk = async () => {
    if (!answerModalUser) return;
    setSavingAnswer(true);
    try {
      const res = await Axios.patch(`${config.USER_SERVER}/${answerModalUser._id}/answer-status`, {
        answer_status_view: answerView,
      });
      if (res.data.success) {
        await filterDatasource(selGroupCode);
        message.success('回答状況指定を保存しました。');
        setAnswerModalUser(null);
      }
    } catch (error) {
      const serverError =
        error && error.response && error.response.data && error.response.data.error;
      message.error(
        serverError ? `回答状況指定の保存に失敗しました。${serverError}` : '回答状況指定の保存に失敗しました。'
      );
      console.log(error);
    } finally {
      setSavingAnswer(false);
    }
  };

  //「シーズン指定」 モーダルを開く
  const openSeasonModal = (user, e) => {
    e.preventDefault();
    //populate 済みの accessible_survey_seasons はオブジェクト配列。ID 文字列の配列に変換
    const currentIds = (user.accessible_survey_seasons || []).map((s) =>
      typeof s === 'string' ? s : String(s._id)
    );
    setSelSeasonIds(currentIds);
    setEditSeasonUid(user._id);
    setEditSeasonUserName(user.fullName);
    setSeasonModalOpen(true);
  };

  //「シーズン指定」 モーダルでの保存
  const handleSeasonOk = async (e) => {
    e.preventDefault();
    try {
      const res = await Axios.patch(
        `${config.USER_SERVER}/${editSeasonUid}/accessible_seasons`,
        { accessible_survey_seasons: selSeasonIds }
      );
      if (res.data.success) {
        await filterDatasource(selGroupCode); //一覧を再取得して件数表示を更新
        message.success('閲覧可能シーズンを保存しました。');
        setSeasonModalOpen(false);
      }
    } catch (error) {
      alert('シーズン保存に失敗しました。');
      console.log(error);
    }
  };

  //「シーズン指定」 モーダルキャンセル
  const handleSeasonCancel = () => {
    setSeasonModalOpen(false);
  };

  //「シーズン指定」 モーダルのチェックボックス変更
  const onSeasonCheckChange = (checkedValues) => {
    setSelSeasonIds(checkedValues);
  };

  //「シーズン指定」 モーダル: 全選択/全解除
  const onSeasonSelectAll = () => {
    setSelSeasonIds(currentGroupSeasons.map((s) => String(s._id)));
  };
  const onSeasonClearAll = () => {
    setSelSeasonIds([]);
  };

  //シーズン表示用ラベル: 「[E³-Survey] 2024年度第1期 / 2024-06-01」
  const seasonLabel = (s) => {
    //サーベイ名は Survey コレクション（正本）の最新名を優先。
    //取得できない場合のみ、シーズンに保存された古い survey_name スナップショットにフォールバック
    const surveyName =
      surveyByCode.get(s.survey_code) || s.survey_name || s.survey_code || '';
    const start = s.survey_start_date
      ? new Date(s.survey_start_date).toISOString().slice(0, 10)
      : '';
    return `[${surveyName}] ${s.season_name || ''}${start ? ` / ${start}` : ''}`;
  };

  //シーズンを survey_code 別にグルーピング (E³-Survey / 360 / その他)
  const groupedSeasons = () => {
    const e3 = [];
    const survey360 = [];
    const others = [];
    (currentGroupSeasons || []).forEach((s) => {
      if (answerStatusKindOf(s.survey_code) === 'engagement') {
        e3.push(s);
      } else if (answerStatusKindOf(s.survey_code) === 'team') {
        // 360度系（360度診断・フォロワーシップ。回答状況指定と同じ分け方。2026-10）
        survey360.push(s);
      } else {
        others.push(s);
      }
    });
    return { e3, survey360, others };
  };

  //「部署指定」モーダルの行操作
  const handleChangeDept = (index, value) => {
    setSelDepts((prev) => prev.map((dep, i) => (i === index ? value || '' : dep)));
  };
  const handleAddDeptRow = () => {
    setSelDepts((prev) => (prev.length >= E3_DEPARTMENT_MAX ? prev : [...prev, '']));
  };
  const handleRemoveDeptRow = (index) => {
    setSelDepts((prev) => {
      const next = prev.filter((_, i) => i !== index);
      return next.length > 0 ? next : [''];
    });
  };
  // 指定中の件数（空欄の行・重複は数えない＝保存される件数）
  const selDeptCount = normalizeE3DepartmentList(selDepts).length;

  // テーブル強化 PJ Ph.3 拡大: メイン一覧の <Column> → columns 配列。テキスト列はソート + 省略、
  // シーズン指定・所属指定列は既存ボタンを維持。
  const rawColumns = [
    ellipsisColumn({
      title: '名前',
      dataIndex: 'fullName',
      key: 'fullName',
      width: 160,
      sorter: textSorter('fullName'),
    }),
    ellipsisColumn({
      title: 'メール',
      dataIndex: 'email',
      key: 'email',
      width: 220,
      sorter: textSorter('email'),
    }),
    // 会社名（系列会社ありグループで「どの会社の人か」を見分けるため。useResizableColumns は
    // マウント時の列構成で幅を決めるため、グループに関係なく常に表示する）
    ellipsisColumn({
      title: '会社',
      dataIndex: 'company',
      key: 'company',
      width: 200,
      sorter: textSorter('company'),
    }),
    ellipsisColumn({
      title: '部署',
      dataIndex: 'department',
      key: 'department',
      width: 180,
      sorter: textSorter('department'),
    }),
    ellipsisColumn({
      title: '役職',
      dataIndex: 'position',
      key: 'position',
      width: 140,
      sorter: textSorter('position'),
    }),
    {
      title: 'シーズン指定',
      key: 'seasons',
      width: 180,
      render: (text, record) => (
        <span>
          <Button
            type={'primary'}
            size="small"
            onClick={(e) => openSeasonModal(record, e)}
            disabled={false}
          >
            シーズン指定 ({record.accessibleSeasonCount || 0})
          </Button>
        </span>
      ),
    },
    {
      title: '所属指定',
      key: 'ticket',
      width: 130,
      render: (text, record) => (
        <span>
          <Button
            size="small"
            onClick={(e) => viewTicketHandler(record, e)}
            disabled={false}
          >
            部署指定
          </Button>
        </span>
      ),
    },
    // 回答状況指定（診断の種類ごとに 閲覧可／閲覧不可。値が無い既存ユーザーはすべて閲覧可。2026-10 追加パッチ）
    {
      title: '回答状況指定',
      key: 'answerStatus',
      width: 200,
      render: (text, record) => {
        const view = answerViewOfRecord(record);
        const hidden = ANSWER_KINDS.filter((k) => !view[k.key]).map((k) => k.short);
        return (
          <Space direction="vertical" size={2}>
            <Button size="small" onClick={(e) => openAnswerModal(record, e)}>
              回答状況指定
            </Button>
            <Text type={hidden.length > 0 ? 'warning' : 'secondary'} style={{ fontSize: 12 }}>
              {hidden.length > 0 ? `閲覧不可：${hidden.join('・')}` : 'すべて閲覧可'}
            </Text>
          </Space>
        );
      },
    },
  ];

  const { columns, components, scroll, wrapRef } = useResizableColumns(rawColumns);

  return (
    <Fragment>
      <PageContainer fluid>
        {(userInfo.role === 9 || userInfo.role === 2) && (
          <div style={{ marginTop: 16, marginBottom: 16 }}>
            ■絞り込み｜企業選択
            <Select
              showSearch
              style={{
                marginBottom: 10,
                marginLeft: 5,
                marginRight: 5,
                width: 200,
              }}
              placeholder="企業選択"
              optionFilterProp="children"
              onChange={onChangeGroup}
              value={selGroupCode}
              filterOption={(input, option) =>
                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
              }
            >
              {groups.map((element) => {
                // console.log({ element });
                return (
                  <Option value={element.group_code} key={element._id}>
                    {element.group_name}
                  </Option>
                );
              })}
            </Select>
            <br />
          </div>
        )}
        {/* 閲覧範囲の考え方（「部署指定拡張」PJ・2026-10。部署指定は組織結果・回答状況・個人結果一括ダウンロードに効く（2026-10-28〜）） */}
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 'var(--space-4)' }}
          message="閲覧範囲（シーズン管理者）の考え方"
          description={
            <ul style={{ margin: 0, paddingLeft: 'var(--space-5)' }}>
              <li>
                <Text strong>シーズン指定</Text>
                {'：選んだシーズンだけを各画面に表示します。E³-Survey のシーズンは「組織結果」を見るシーズン、360度系（360度診断・フォロワーシップ）は「チーム回答状況」、その他は「メンバー回答状況」に出すシーズンです。未選択の場合はすべてのシーズンが対象です。1つでも選ぶと、選んだシーズン以外は表示されません（例：E³-Survey のシーズンだけを選ぶと、360度系・その他のシーズンは表示されません）。'}
              </li>
              <li>
                <Text strong>部署指定</Text>
                {'：指定した部署とその配下だけが対象になります。組織結果（E³-Survey）はその部署だけで集計し、「メンバー回答状況」「チーム回答状況」「個人結果一括ダウンロード」はその部署の人（今の所属）だけを表示します。「チーム回答状況」は本人（評価される人）の所属で判定し、本人のチームであれば他の部署の協力者の回答状況も表示します。指定がない場合はすべての部署が対象です。'}
              </li>
              <li>
                <Text strong>回答状況指定</Text>
                {'：診断の種類（エンゲージメント／360度系／その他）ごとに、回答状況（だれが回答済み・未回答か）を見られるかを決めます。エンゲージメントとその他は「メンバー回答状況」で選べるシーズン、360度系は「チーム回答状況」のメニューに効きます。エンゲージメントの回答状況はシーズン指定に関係なく、すべてのシーズンが対象です。現場の管理職の方が未回答者を特定できないようにするための設定です。組織結果・個人結果一括ダウンロードは今までどおりです。初期値はすべて「閲覧可」です。'}
              </li>
              {isAffiliateGroup && (
                <li>
                  <Text strong>系列会社</Text>
                  {'：部署指定は「系列会社」または「系列会社／所属」で指定します。系列会社だけを指定すると、その会社の社員全員が対象になります。部署指定がない場合はすべての系列会社が対象です。'}
                </li>
              )}
            </ul>
          }
        />
        {bulkModel && (
          <div style={{ marginBottom: 'var(--space-4)' }}>
            <Space wrap size="middle">
              <Button icon={<DownloadOutlined />} onClick={handleTemplateDownload}>
                テンプレートダウンロード
              </Button>
              <Button icon={<DownloadOutlined />} onClick={handleCurrentDownload} disabled={gUsers.length === 0}>
                現在の設定をダウンロード
              </Button>
              <Button icon={<UploadOutlined />} onClick={() => setBulkModalOpen(true)}>
                Excel一括登録
              </Button>
              {bulkModel.available ? (
                <Text type="secondary">
                  部署指定・シーズン指定・回答状況指定をExcelで一括登録できます（部署は組織表「{bulkVersion && bulkVersion.name}」
                  {bulkVersion && formatYmd(bulkVersion.effective_from)}〜 から、シーズンはこの企業の全シーズンから選択）。
                  「現在の設定をダウンロード」は、今の登録内容を同じ形のファイルで出力します（直して取り込めます）。
                </Text>
              ) : (
                <Text type="secondary">
                  シーズン指定・回答状況指定をExcelで一括登録できます（シーズンはこの企業の全シーズンから選択）。
                  部署指定は、今日時点で有効な確定組織表が無いため一括登録できません（画面の「部署指定」から設定してください。組織表を確定すると一括登録も使えます）。
                  「現在の設定をダウンロード」は、今の登録内容を同じ形のファイルで出力します（直して取り込めます）。
                </Text>
              )}
            </Space>
          </div>
        )}
        <div ref={wrapRef}>
          <Table
            columns={columns}
            components={components}
            scroll={scroll}
            dataSource={gUsers}
            size="middle"
            rowKey="_id"
          />
        </div>
      </PageContainer>
      <div>
        <Modal
          title="部署指定"
          open={viewModal}
          onOk={handleOk}
          onCancel={handleCancel}
          confirmLoading={savingDepts}
          destroyOnHidden
          styles={{ body: { maxHeight: '60vh', overflowY: 'auto', overflowX: 'auto' } }}
          width={900}
          okText={'保存'}
          cancelText={'キャンセル'}
        >
          <Text>※最大{E3_DEPARTMENT_MAX}部署まで指定可能です。</Text>
          <br />
          <Text>
            ※組織結果（E³-Survey）は、指定した部署とその配下だけで集計されます（部署で絞り込むのは組織結果のみです）。
          </Text>
          <br />
          {isAffiliateGroup && (
            <>
              <Text>
                {'※系列会社を指定するとその会社全体、所属まで指定するとその配下が対象です（組織結果・メンバー回答状況・チーム回答状況・個人結果一括ダウンロード）。'}
              </Text>
              <br />
            </>
          )}
          <Text type="danger">
            ※部署に指定がない場合、全ての部署の結果が閲覧できます。
          </Text>
          <div style={{ margin: 'var(--space-4) 0' }}>
            <Space direction="vertical" size="middle" style={{ display: 'flex' }}>
              {selDepts.map((dep, index) => (
                <Space key={index} direction="horizontal" size="middle" style={{ display: 'flex' }}>
                  <Text type="secondary" style={{ display: 'inline-block', minWidth: 'var(--space-8)' }}>
                    {index + 1}.
                  </Text>
                  <TreeSelect
                    {...DEPT_TREE_SELECT_PROPS}
                    style={{ width: 360 }}
                    treeData={treeData}
                    placeholder="部署を選択"
                    onSelect={(value) => handleChangeDept(index, value)}
                    value={dep || undefined}
                  />
                  <Button
                    danger
                    size="small"
                    icon={<DeleteOutlined />}
                    aria-label={`${index + 1} 行目を削除`}
                    disabled={selDepts.length === 1 && dep === ''}
                    onClick={() => handleRemoveDeptRow(index)}
                  >
                    削除
                  </Button>
                  <Text>{dep}</Text>
                </Space>
              ))}
            </Space>
          </div>
          <Space size="middle">
            <Button
              icon={<PlusOutlined />}
              onClick={handleAddDeptRow}
              disabled={selDepts.length >= E3_DEPARTMENT_MAX}
            >
              行を追加
            </Button>
            <Text type="secondary">
              指定中: {selDeptCount} / {E3_DEPARTMENT_MAX} 件
            </Text>
          </Space>
        </Modal>

        {bulkModel && (
          <E3DeptBulkUploadModal
            open={bulkModalOpen}
            groupCode={selGroupCode}
            model={bulkModel}
            onClose={() => setBulkModalOpen(false)}
            onDone={handleBulkDone}
          />
        )}

        {/* 「回答状況指定」モーダル: 診断の種類ごとに回答状況を見られるか（2026-10 追加パッチ） */}
        <Modal
          title={`回答状況指定 ${answerModalUser ? `- ${answerModalUser.fullName}` : ''}`}
          open={!!answerModalUser}
          onOk={handleAnswerOk}
          onCancel={() => setAnswerModalUser(null)}
          confirmLoading={savingAnswer}
          width={640}
          okText={'保存'}
          cancelText={'キャンセル'}
        >
          <Text>※チェックあり＝閲覧可、チェックなし＝閲覧不可です。回答状況は「だれが回答済み・未回答か」のことです。</Text>
          <br />
          <Text>※「エンゲージメント」と「その他」の両方を閲覧不可にすると、「メンバー回答状況」のメニューが出なくなります。</Text>
          <div style={{ marginTop: 12 }}>
            {ANSWER_KINDS.map((k) => (
              <div key={k.key} style={{ marginBottom: 12 }}>
                <Space align="start">
                  <Text strong style={{ display: 'inline-block', width: 260 }}>
                    {k.label}
                  </Text>
                  <Checkbox
                    checked={answerView[k.key]}
                    onChange={(e) => setAnswerView((v) => ({ ...v, [k.key]: e.target.checked }))}
                  >
                    {answerView[k.key] ? '閲覧可' : '閲覧不可'}
                  </Checkbox>
                </Space>
                <Text type="secondary" style={{ display: 'block', fontSize: 12 }}>
                  {k.help}
                </Text>
              </div>
            ))}
          </div>
        </Modal>

        {/* 「シーズン指定」 モーダル: role 7 ユーザーが閲覧可能なシーズンを複数選択 */}
        <Modal
          title={`シーズン指定 ${editSeasonUserName ? `- ${editSeasonUserName}` : ''}`}
          open={seasonModalOpen}
          onOk={handleSeasonOk}
          onCancel={handleSeasonCancel}
          styles={{ body: { maxHeight: '60vh', overflowY: 'auto' } }}
          width={900}
          okText={'保存'}
          cancelText={'キャンセル'}
        >
          <Text>
            ※対象ユーザーがこの企業内で閲覧可能な調査シーズンを選択してください。
          </Text>
          <br />
          <Text>
            ※未選択の場合は、すべてのシーズンが閲覧対象になります。1つでも選ぶと、選んだシーズン以外は表示されません。
          </Text>
          <br />
          <Text type="danger">
            ※E³-Survey の組織結果を閲覧させる場合は、E³-Survey のシーズンを必ず含めてください。
          </Text>
          <div style={{ marginTop: 12, marginBottom: 12 }}>
            <Space>
              <Button size="small" onClick={onSeasonSelectAll}>
                全て選択
              </Button>
              <Button size="small" onClick={onSeasonClearAll}>
                全て解除
              </Button>
              <Text type="secondary">
                選択中: {selSeasonIds.length} / {currentGroupSeasons.length} 件
              </Text>
            </Space>
          </div>
          {currentGroupSeasons.length === 0 ? (
            <EmptyState message="このグループには登録されたシーズンがありません" />
          ) : (
            <Checkbox.Group
              value={selSeasonIds}
              onChange={onSeasonCheckChange}
              style={{ width: '100%' }}
            >
              {(() => {
                const { e3, survey360, others } = groupedSeasons();
                const renderGroup = (label, list) =>
                  list.length > 0 && (
                    <div key={label} style={{ marginBottom: 16 }}>
                      <Text strong style={{ display: 'block', marginBottom: 6 }}>
                        ━ {label} ({list.length}件)
                      </Text>
                      <Space direction="vertical" style={{ width: '100%' }}>
                        {list.map((s) => (
                          <Checkbox key={String(s._id)} value={String(s._id)}>
                            {seasonLabel(s)}
                          </Checkbox>
                        ))}
                      </Space>
                    </div>
                  );
                return (
                  <Fragment>
                    {renderGroup('E³-Survey（組織結果を見るシーズン）', e3)}
                    {renderGroup('360度系：360度診断・フォロワーシップ（チーム回答状況）', survey360)}
                    {renderGroup('その他（メンバー回答状況）', others)}
                  </Fragment>
                );
              })()}
            </Checkbox.Group>
          )}
        </Modal>
      </div>
    </Fragment>
  );
}

export default E3DepMgrPage;
